import { useEffect, useState } from 'react';
import { Row, Col, Form, Input, Select, FormInstance, Modal } from 'antd';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import Switch from '../../Molecules/Switch/Switch';
import User from '../../../models/User';
import Rol from '../../../models/Rol';
import { isEmpty, setAccessArray } from '../../../utils/functions';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { getRoles, selectRol } from '../../../store/slice/rolSlice';
import './UserForm.less';
/**
 * @component AddUserForm.tsx
 * @description AddUserForm component to create add user post.
 * @return { Component }
 */
interface AddUserFormProps {
  user: User;
  form: FormInstance;
  userDelete: (isModal: boolean, user: User) => void;
}
function AddUserForm(props: AddUserFormProps) {
  const { Option } = Select;
  const dispatch = useAppDispatch();
  const { confirm } = Modal;
  const rolState = useAppSelector(selectRol);
  const [isRoleType, setIsRoleType] = useState(0);
  const [roles, setRoles] = useState<Rol[]>([]);
  const [accessSelected, setAccessSelected] = useState<string[]>([]);
  const [enableUser, setEnableUser] = useState(false);

  const onChange = (selectValue: Array<string>) => {
    setAccessSelected([...selectValue])
    if (selectValue.includes('accesoGestion')) {
      setIsRoleType(1);
      setRoles(rolState.rolesList);
    } else {
      setIsRoleType(0);
      props.form.setFieldsValue({
        rol: null,
        rolId: null,
      });
    }
  };
  const isEnabled = (enable: boolean) => {
    setEnableUser(enable);
    props.form.setFieldsValue({
      estado: enable ? 1 : 2,
      check: enable,
    });
  };
  const userDelete = () => {
    confirm({
      title: '¿Quieres eliminar el usuario?',
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          Esta acción lo eliminará por completo <br /> y es irreversible.
        </>
      ),
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk() {
        props.userDelete(false, props.user);
      },
    });
  };
  const handleChange = (value: number) => {
    let findRolForId = roles.find((x) => x.id === value);
    props.form.setFieldsValue({
      rolId: value,
      rol: findRolForId,
    });
  };
  useEffect(() => {
    if (isEmpty(props.user)) {
      setIsRoleType(0);
    } else {
      if (props.user.accesoGestion) {
        setIsRoleType(1);
      } else {
        setIsRoleType(0);
      }
      if (roles.length !== 1) {
        setRoles(rolState.rolesList);
      } else {
        dispatch(getRoles()).then((value: any) => {
          if (value.payload.status) {
            let rolData = value.payload.data;
            setRoles(rolData);
          } else {
            setRoles([]);
          }
        });
      }
      const accessArray = setAccessArray({accesoAdministracion: props.user.accesoAdministracion, accesoCatastro: props.user.accesoCatastro, accesoGestion: props.user.accesoGestion,accesoRegistros:props.user.accesoRegistros}, false)
      let formData = {
        nombre: props.user.nombre,
        apellido: props.user.apellido,
        email: props.user.email,
        celular: props.user.celular,
        dni: props.user.dni,
        tipo: accessArray,
        rolId: props.user.rolId,
        rol: props.user.rol,
        estado: props.user.estado,
        check: props.user.estado === 1 ? true : false,
      };
      props.form.setFieldsValue(formData);
      if (props.user.estado === 1) {
        setEnableUser(true);
      } else {
        setEnableUser(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user, props.form]);
  return (
    <div className="org-user-form">
      <Row>
        <Col span={24}>
          <Form layout={'vertical'} form={props.form} name="addUserForm">
            <Form.Item
              name={'nombre'}
              required={true}
              label="Nombre"
              style={{fontWeight:'bold'}}
              rules={[
                { required: true, message: 'Por favor ingrese su nombre.' },
              ]}
            >
              <Input
                required
                placeholder={'Ingresa el nombre'}
                value={isEmpty(props.user) ? '' : props.user.nombre}
              />
            </Form.Item>
            <Form.Item
              name={'apellido'}
              required={true}
              label="Apellido"
              style={{fontWeight:'bold'}}
              rules={[
                { required: true, message: 'Por favor ingrese su apellido.' },
              ]}
            >
              <Input
                placeholder={'Ingresa el apellido'}
                value={isEmpty(props.user) ? '' : props.user.apellido}
              />
            </Form.Item>
            <Form.Item
              name={'dni'}
              required={true}
              label="DNI"
              style={{fontWeight:'bold'}}
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese su DNI.',
                },
                {
                  pattern: /^([-]?[1-9][0-9]*|0)$/,
                  message: "Solo se permite numeros"
                }
              ]}
            >
              <Input
                className="org-user-form__dni__input"
                placeholder={'Ingresa el DNI'}
                value={isEmpty(props.user) ? '' : String(props.user.dni)}
              />
            </Form.Item>
            <Form.Item
              name={'email'}
              required={true}
              label="Correo Electrónico"
              style={{fontWeight:'bold'}}
              rules={[
                {
                  type: 'email',
                  required: true,
                  message: 'Por favor ingrese su correo electrónico.',
                },
              ]}
            >
              <Input
                placeholder={
                  isEmpty(props.user)
                    ? 'Ingresa el correo electrónico'
                    : props.user.email
                }/>
            </Form.Item>
            <Form.Item
              name={'celular'}
              required={true}
              label="N° de Teléfono"
              style={{fontWeight:'bold'}}
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese su N° de teléfono.',
                },
                {
                  pattern: /^([-]?[1-9][0-9]*|0)$/,
                  message: "Solo se permite numeros"
                }
              ]}
            >
              <Input
                placeholder={'Ingresa el número de teléfono'}
                value={isEmpty(props.user) ? '' : props.user.celular}
              />
            </Form.Item>
            <Form.Item
              required={true}
              name={'tipo'}
              style={{fontWeight:'bold'}}
              label="Acceso"
              tooltip={{
                title: 'Selecciona uno o mas accesos',
                icon: <QuestionCircleOutlined style={{ color: '#262626' }} />,
                color: '#262626',
              }}
              rules={[
                {
                  required: true,
                  message: 'Por favor seleccione sus tipos de acceso.',
                },
              ]}
            >
              <Select
                placeholder="Acceso"
                mode="multiple"
                allowClear
                maxTagCount={1}
                onChange={onChange}
              >
                <Option value={'accesoAdministracion'}>Administración</Option>
                <Option value={'accesoGestion'}>Gestor de Tareas</Option>
                <Option value={'accesoCatastro'}>Gestor de Capas</Option>
                <Option value={'accesoRegistros'}>Gestor de Registros</Option>
              </Select>
            </Form.Item>
            {isRoleType === 1 && (
              <Form.Item
                required={true}
                name={'rolId'}
                style={{fontWeight:'bold'}}
                label="Rol:"
                rules={[
                  {
                    required: true,
                    message: 'Por favor selecciona un rol para continuar.',
                  },
                ]}
              >
                <Select
                  placeholder="Selecciona un rol para continuar"
                  optionFilterProp="children"
                  onChange={handleChange}
                >
                  {roles.map(
                    (item) =>
                      item.activo && (
                        <Option value={item.id} key={item.id}>
                          {item.rol}
                        </Option>
                      ),
                  )}
                </Select>
              </Form.Item>
            )}
            {isEmpty(props.user) ? (
              ''
            ) : (
              <>
                {props.user.estado !== 0 && (
                  <Form.Item name="check">
                    <Switch value={enableUser} isEnabled={isEnabled} />
                  </Form.Item>
                )}
              </>
            )}
            {isEmpty(props.user) ? (
              ''
            ) : (
              <div className="org-task-form__delete">
                <div className="icon-delete" onClick={userDelete}>
                  <DeleteOutlined /> Eliminar
                </div>
              </div>
            )}
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default AddUserForm;
